import Api from '..'
import { ProductCollectionItemPublic } from '../products/types'

export default class SearchApi extends Api {
  public endpoint = '/search'

  public async searchProducts(
    query: string
  ): Promise<ProductCollectionItemPublic[]> {
    const response = await this.http.get(this.endpoint, {params: { q: query } })
    const responseData: ProductCollectionItemPublic[] = response.data
    return responseData
  }
}
